<template>
  <div>
    <div :class="theme == 1 ? 'white' : 'black'" style="height: 100vh; width: 100%;overflow:hidden; overflow-y: auto"
      @scroll="scrollEvent($event)">
      <div class="main_top" :class="'main_top_' + active">
        <van-nav-bar v-if="navshow" :class="navopacity == 0 ? 'textColor1' : 'textColor'" :style="{
          paddingTop: statusBarHeight,
          height: navigationBarHeight,
          background: backgroundColor,
          zIndex: 1000
        }" title="我的会员" left-text="" right-text="" :fixed="true" :placeholder="false" left-arrow
          :safe-area-inset-top="true" @click-left="onClickLeft">
          <van-icon class="iconImg" :name="navopacity == 0
            ? NavleftIcon
            : theme == 2 ? NavleftIcon : NavleftIcon2
          " slot="left" />
        </van-nav-bar>
        <div class="swiper mySwiper" :style="'padding-top:' + martop">
          <swiper :options="swiperOption">
            <swiper-slide class="swiper-slide" v-for="(item, i) in swiperList" :key="i">
              <div class="card" :class="'swipe' + i">
                <img :class="'icon_vip' + i" :src="i == 0 ? vip0 : i == 1 ? vip1 : i == 2 ? vip2 : vip3" alt="" />
                <div class="card_main" style="padding:0.33rem 0.4rem 0.29rem 0.4rem">

                  <div style="display:flex;justify-content: space-between;">
                    <div style="display:flex">
                      <van-image round width="0.8rem" height="0.8rem" :src="info.avatar" />
                      <div style="padding-left:0.15rem">
                        <p class="fs30 fw500" :class="theme == 1 ? 'color333' : 'color333'">{{ info.name | ellipsis }}
                        </p>
                        <p class="fs22 color676d78" style="padding-top:0.05rem" v-if="item.isopen == 1">
                          {{ item.name }}
                          <span v-if="item.isopen == 1 && i != 0">{{ item.expdate }} 到期</span>
                        </p>
                        <p class="fs22 color676d78" v-else>您还未开通{{ item.name }}
                        </p>
                      </div>
                    </div>
                    <div style="text-align:right" class="fs24">
                      <p class="color3c">当前财富权益</p>
                      <p class="color3c" style="padding-top:0.05rem">
                        <span class="colorFA3B32">{{ item.quantity }}</span>项
                      </p>
                    </div>
                  </div>
                  <p class="fs42 fw500 colors" style=" line-height:0.99rem;padding-top:0.3rem">
                    {{ item.name }}
                  </p>
                  <div class="xian1">
                    <div class="xian2">
                      V{{ i + 1 }}
                    </div>
                  </div>
                  <div class="dian">
                    <p :class="i == 0 ? 'activedian' : ''"></p>
                    <p :class="i == 1 ? 'activedian' : ''"></p>
                    <p :class="i == 2 ? 'activedian' : ''"></p>
                    <p :class="i == 3 ? 'activedian' : ''"></p>
                  </div>
                  <!-- <p style="width:4.5rem;color:#342E2A;line-height: 0.42rem ;" class="fs28 content">
                    {{ item.content }}
                  </p>
                  <div class="btn" :class="'btn' + i" @click="
                    goPayPage(active == 0 ? swiperList[1] : swiperList[active])
                  ">
                    开通会员
                  </div> -->
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div class="list" :style="isSHow ? 'height:2.37rem;overflow:hidden' : ''">
          <div class="title">
            <p>
              <img style="width:0.26rem;height:0.26rem" src="../assets/icon31.png" alt="" /><span>{{
                  swiperList[active].amount
              }}种投顾礼包</span>
              <img style="width:0.3rem;height:0.26rem" src="../assets/icon34.png" alt="" /><span>{{
                  swiperList[active].quantity
              }}项财富权限</span>
            </p>
            <p class="more" @click="isSHow = !isSHow"><span>{{ isSHow ? "展开" : "收起" }}</span><img
                :src="isSHow ? xia5 : xia6" alt="">
            </p>

          </div>
          <ul :style="isSHow ? 'height:1.17rem;overflow:hidden' : ''" v-if="active == 0">
            <li v-for="(item, i) in list1" :key="i">
              <div class="item_title">{{ item.name }}</div>
              <div class="pname">
                <div v-for="(p, index) in item.pros" :key="index">
                  <p></p>
                  <span>{{ p.name }}</span>
                </div>
              </div>
            </li>
          </ul>
          <ul :style="isSHow ? 'height:1.17rem;overflow:hidden' : ''" v-if="active == 1">
            <li v-for="(item, i) in list2" :key="i">
              <div class="item_title">{{ item.name }}</div>
              <div class="pname">
                <div v-for="(p, index) in item.pros" :key="index">
                  <p></p>
                  <span>{{ p.name }}</span>
                </div>
              </div>
            </li>
          </ul>
          <ul :style="isSHow ? 'height:1.17rem;overflow:hidden' : ''" v-if="active == 2">
            <li v-for="(item, i) in list3" :key="i">
              <div class="item_title">{{ item.name }}</div>
              <div class="pname">
                <div v-for="(p, index) in item.pros" :key="index">
                  <p></p>
                  <span>{{ p.name }}</span>
                </div>
              </div>
            </li>
          </ul>
          <ul :style="isSHow ? 'height:1.17rem;overflow:hidden' : ''" v-if="active == 3">
            <li v-for="(item, i) in list4" :key="i">
              <div class="item_title">{{ item.name }}</div>
              <div class="pname">
                <div v-for="(p, index) in item.pros" :key="index">
                  <p></p>
                  <span>{{ p.name }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

      </div>


      <div style="padding-bottom: 1.3rem;" :style="theme == 1 ? 'background: #fff' : 'background: #1E1F26;'">
        <div class="hytitle">
          <p>{{ swiperList[active].name }}权益</p>
          <p class="fs26 fw500" style="
color: #f73e3a;">手机超级LEVEL2</p>
        </div>
        <img style="padding:0.08rem 0.3rem;width:6.97rem" :src="
          theme == 2
            ? picHost + swiperList[active].imglong
            : picHost + swiperList[active].imgshort
        " alt="" />
      </div>

      <div class="sub-boot" style="padding: 8px 16px">
        <van-button type="info"  round v-if="active != 0" @click="goPayPage(active == 0 ? swiperList[1] : swiperList[active])"
          color="#F44336" block>{{
              swiperList[active].isopen == 2
                ? "开通" + swiperList[active].name
                : "续费" + swiperList[active].name
          }}</van-button>
        <van-button type="info"  round v-else @click="goPayPage(active == 0 ? swiperList[1] : swiperList[active])"
          color="#F44336" block>{{
              swiperList[1].isopen == 2
                ? "开通" + swiperList[1].name
                : "续费" + swiperList[1].name
          }}</van-button>
        <span class="agreement">
          开通表示您同意
          <a href="javascript:;" @click="goAgreementPage" style="color: #3395ff">《启明星增值服务协议》</a>
        </span>
      </div>
    </div>
    <div>
        <div class="main_top_1"></div>
        <div class="main_top_2"></div>
        <div class="main_top_3"></div>
        <div class="main_top_4"></div>
    </div>
  </div>
</template>

<script>
import {  NavBar, Image, Icon, Button, Toast } from "vant";
var picHost = process.env.VUE_APP_PIC_BASE_URL;
var picHost1 = process.env.VUE_APP_HTTP_BASE_URL
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
import api from "@/api/mall";
import inobounce from "inobounce";
import Vue from 'vue'
import '../css/swiper-bundle.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

let vm = null
export default {
  components: {
    // [Swipe.name]: Swipe,
    // [SwipeItem.name]: SwipeItem,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Toast.name]: Toast,

  },
  data() {
    return {
      show: false,
      show1: true,
      noBtn: false,
      statusBarHeight: "",
      navigationBarHeight: "",
      info: {},
      picHost: picHost,
      isSHow: true,
      navopacity: 0,
      backgroundColor: "rgba(18, 22, 31,0)",
      LevelName: {
        0: "大众会员",
        1: "黄金会员",
        2: "铂金会员",
        3: "钻石会员",
      },
      NavleftIcon: require("../assets/left2.png"),
      NavleftIcon2: require("../assets/left1.png"),
      vip0: require("../assets/vip0.png"),
      vip1: require("../assets/vip1.png"),
      vip2: require("../assets/vip2.png"),
      vip3: require("../assets/vip3.png"),
      xia1: require("../assets/xia1.png"),
      xia2: require("../assets/xia2.png"),
      xia3: require("../assets/xia3.png"),
      xia4: require("../assets/xia4.png"),
      xia5: require("../assets/xia5.png"),
      xia6: require("../assets/xia6.png"),
      top2: require("../assets/top_bg2.png"),
      top3: require("../assets/top_bg3.png"),
      top4: require("../assets/top_bg4.png"),
      LevelColor: {
        0: "#4091ff",
        1: "#dab189",
        2: "#808ac7",
        3: "#403639",
      },
      LevelMsg: "",
      NextLevelMsg: "",
      PushUsersNum: "",
      TeamUsersNum: "",
      TeamRate: "",
      nowNevel: "",
      userName: "",
      active: 0,
      swiperList: [],
      list: [
        {
          title: "K线形态",
          children: ["早晨之光", "形态选股", "智能股池", "早晨之光"],
        },
        {
          title: "策略股池",
          children: [
            "早晨之光",
            "形态选股",
            "智能股池",
            "打新日历",
            "智能股池",
            "打新日历",
            "智能股池",
            "智能股池",
          ],
        },
        {
          title: "独家资讯",
          children: ["早晨之光", "形态选股", "智能股池", "智能股池"],
        },
        {
          title: "K线形态",
          children: ["早晨之光", "形态选股", "智能股池", "打新日历"],
        },
      ],
      navshow: true,
      martop: "",
      swiperOption: {
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: false // 允许点击小圆点跳转
        // },
        // autoplay: {
        //     delay: 35000,
        //     disableOnInteraction: false // 手动切换之后继续自动轮播
        // },

        // slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。
        grabCursor: true,//小手掌抓取滑动
        // loop: true,
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev'
        // },
        centeredSlides: true,
        slidesPerView: "auto",
        on: {
          slideChangeTransitionEnd: function () {
            // 点击小图, 大图对应切换
            // const index = this.pngListNoLabel.findIndex((i) => i.imgSrc === e.target.attributes.src.nodeValue);
            vm.active = this.activeIndex
            // this.swiper.realIndex = index;
            // this.swiper.activeIndex = index + 5;
            // this.swiper.slideTo(index + 5);
            // this.$emit('setBigIndex', index);
          },


        },
      },
      list1: [],
      list2: [],
      list3: [],
      list4: [],
    };
  },

  filters: {
    nameellipsis(value) {
      if (!value) return "";
      if (value.length > 20) {
        let len = value.length;
        return value.substring(0, 7) + "..." + value.substring(len - 6, len);
      }
      return value;
    },

    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
    titleellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    },
  },
  mounted() {
    var that = this;
    if (getBrowserUserAgent().android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
      this.$bridge.registermethod("refreshToken", function (responseData) {
        responseData = JSON.parse(responseData);
        that.userId = responseData.userId;
        that.userToken = responseData.userToken;
        sessionStorage.setItem("userId", that.userId);
        sessionStorage.setItem("Access-Token", that.userToken);
        that.getSubList();
      });
    } else {
      connectWebViewJavascriptBridge(() => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler("changeTheme", function (
          responseData
        ) {
          responseData = JSON.parse(responseData);
          that.theme = responseData;
          sessionStorage.setItem("theme", responseData);
        });
        window.WebViewJavascriptBridge.registerHandler("refreshToken", function (
          responseData
        ) {
          responseData = JSON.parse(responseData);
          that.userId = responseData.userId;
          that.userToken = responseData.userToken;
          sessionStorage.setItem("userId", that.userId);
          sessionStorage.setItem("Access-Token", that.userToken);
          that.getSubList();
        });
      });
    }
  },
  watch: {
    active(val) {
      // console.log(val)
      //  console.log(this.swiperList[val].level)
      this.productList(val, this.swiperList[val].level);
      this.isSHow = true
      // this.acticitystock();
    },

  },
  created() {
    vm = this
    this.theme = sessionStorage.getItem("theme");
    this.statusBarHeight = this.$route.query.statusBarHeight + "px";
    this.navigationBarHeight = this.$route.query.navigationBarHeight + "px";
    this.martop =
      parseInt(this.$route.query.statusBarHeight) +
      parseInt(this.$route.query.navigationBarHeight) + 5 +
      "px";
    console.log(this.martop);
    if (this.$route.query.statusBarHeight) {
      this.navshow = true;
    }
    let u = navigator.userAgent;
    if (u.indexOf("iPhone") > -1) {
      inobounce.enable();
    }
    this.productList(0, 1);
    this.userInfo();
    this.membershipDetails();


  },
  methods: {
    onClickLeft() {
      if (getBrowserUserAgent().android) {
        this.$bridge.callmethod("closeContainer");
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "closeContainer",
          function () { }
        );
      }
    },

    userInfo() {
      api.userInfo({}).then((res) => {
        if (res.code == 200) {
          this.info = res.data;
        }
      });
    },
    goAgreementPage() {
      // var query = {
      //   name: this.product.name,
      //   theme: this.theme,
      // };
      var url =
        picHost1 +
        "/mall/xieyi?theme=" + this.theme + "&token=" +
        sessionStorage.getItem("Access-Token");
      // this.$router.push({ path: "/xieyi", query: query });
      if (getBrowserUserAgent().android) {
        this.$bridge.callmethod("webPushNative", {
          action: "h5",
          param: { url: url },
        });
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "webPushNative",
          { action: "h5", param: { url: url } },
          function () { }
        );
      }
    },
    membershipDetails() {
      const params = {
        levels: [1, 22, 18, 21],
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      api.membershipDetails(params).then((res) => {
        Toast.clear();
        this.swiperList = res.data;
      });
    },
    productList(index, level) {
      const params = {
        level: level,
      };

      api.productList(params).then((res) => {

        // this.list = res.data.productlist;
        if (res.code == 200) {
          if (index == 0) {
            this.list1 = res.data.productlist
          } else if (index == 1) {
            this.list2 = res.data.productlist
          } else if (index == 2) {
            this.list3 = res.data.productlist
          } else if (index == 3) {
            this.list4 = res.data.productlist
          }

        }
      });
    },
    goPayPage(item) {
      var query = {
        type: item.classify.id,
        id: item.level,
        theme: this.theme,
      };
      if (item.isopen == 1) {
        query.isRenewal = true;
      }
      sessionStorage.setItem("productId", this.productId);

      sessionStorage.setItem("producttype", this.type);
      // this.$router.push({ path: "/pay", query: query });
      var url =
        picHost1 +
        "/mall/pay?type=" + item.classify.id + "&id=" + item.level + "&theme=" + this.theme + "&token=" +
        sessionStorage.getItem("Access-Token");
      if (getBrowserUserAgent().android) {
        this.$bridge.callmethod("webPushNative", {
          action: "h5",
          param: { url: url },
        });
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "webPushNative",
          { action: "h5", param: { url: url } },
          function () { }
        );
      }
    },
    scrollEvent(e) {
      // let tbodyRightScrollLeft = e.target.scrollLeft;
      let tbodyRightScrollTop = e.target.scrollTop;
      // this.$refs.titsRight.scrollLeft = tbodyRightScrollLeft;
      // this.$refs.tbodyLeft.scrollTop = tbodyRightScrollTop;
      // console.log(tbodyRightScrollTop);
      if (this.theme == 1) {
        if (tbodyRightScrollTop == 0) {
          this.backgroundColor = "rgba(18, 22, 31,0)";
          this.navopacity = 0;
        } else if (tbodyRightScrollTop < 10) {
          this.navopacity = 0;
          this.backgroundColor = "rgba(255,255,255,0.2)";
        } else if (tbodyRightScrollTop < 20) {
          this.navopacity = 0.2;
          this.backgroundColor = "rgba(255,255,255,0.4)";
        } else if (tbodyRightScrollTop < 30) {
          this.navopacity = 0.3;
          this.backgroundColor = "rgba(255,255,255,0.6)";
        } else if (tbodyRightScrollTop < 40) {
          this.navopacity = 0.4;
          this.backgroundColor = "rgba(255,255,255,0.8)";
        } else if (tbodyRightScrollTop < 50) {
          this.navopacity = 0.7;
          this.backgroundColor = "rgba(255,255,255,0.9)";
        } else if (tbodyRightScrollTop > 60) {
          this.navopacity = 0.9;
          this.backgroundColor = "rgba(255,255,255,1)";
        } else if (tbodyRightScrollTop > 70) {
          this.navopacity = 1;
          this.backgroundColor = "rgba(255,255,255,1)";
        } else if (tbodyRightScrollTop > 150) {
          this.navopacity = 1;
          this.backgroundColor = "rgba(255,255,255,1)";
        }
      } else {
        if (tbodyRightScrollTop == 0) {
          this.backgroundColor = "rgba(18, 22, 31,0)";
          this.navopacity = 0;
        } else if (tbodyRightScrollTop < 10) {
          this.navopacity = 0;
          this.backgroundColor = "rgba(18, 22, 31,0.2)";
        } else if (tbodyRightScrollTop < 20) {
          this.navopacity = 0.2;
          this.backgroundColor = "rgba(18, 22, 31,0.4)";
        } else if (tbodyRightScrollTop < 30) {
          this.navopacity = 0.3;
          this.backgroundColor = "rgba(18, 22, 31,0.6)";
        } else if (tbodyRightScrollTop < 40) {
          this.navopacity = 0.4;
          this.backgroundColor = "rgba(18, 22, 31,0.8)";
        } else if (tbodyRightScrollTop < 50) {
          this.navopacity = 0.7;
          this.backgroundColor = "rgba(18, 22, 31,0.9)";
        } else if (tbodyRightScrollTop > 60) {
          this.navopacity = 0.9;
          this.backgroundColor = "rgba(18, 22, 31,1)";
        } else if (tbodyRightScrollTop > 70) {
          this.navopacity = 1;
          this.backgroundColor = "rgba(18, 22, 31,1)";
        } else if (tbodyRightScrollTop > 150) {
          this.navopacity = 1;
          this.backgroundColor = "rgba(18, 22, 31,1)";
        }
      }
      var that = this;
      if (tbodyRightScrollTop > 70) {
        if (that.top100 == 1) {
          // console.log(that.top100);
          if (getBrowserUserAgent().android) {
            //状态栏颜色 true 黑色 false白色

            that.$bridge.callmethod("statusBarDarkFont", true, function (
              
            ) { });
          } else {
            connectWebViewJavascriptBridge(() => {
              window.WebViewJavascriptBridge.callHandler(
                "statusBarDarkFont",
                true,
                function () { }
              );
            });
          }
        }
        that.top100 = 2;
      } else {
        if (that.top100 == 2) {
          // console.log(that.top100);
          if (getBrowserUserAgent().android) {
            that.$bridge.callmethod("statusBarDarkFont", false, function (
              
            ) { });
          } else {
            connectWebViewJavascriptBridge(() => {
              window.WebViewJavascriptBridge.callHandler(
                "statusBarDarkFont",
                false,
                function () { }
              );
            });
          }
        }
        that.top100 = 1;
      }
    },
    onChange(index) {
      this.active = index;
      console.log(index, this.$refs.swipe);
    },
  },
};
</script>

<style lang="less" scoped>
.main_top {
  // background-color: #fff;
  background-size: 7.5rem 4.31rem;

}

@import url("../css/swiper-bundle.min.css");

.main_top_0 {
  background: #fff url(../assets/top_bg1.png) no-repeat;
  background-size: 7.5rem 4.31rem;

  .colors {

    color: #1E5276;
  }

  .xian2 {

    color: #8AB4DD;
  }
}

.main_top_1 {
  background: #fff url(../assets/top_bg2.png) no-repeat;
  background-size: 7.5rem 4.31rem;

  .colors {
    color: #40636C;
  }

  .xian2 {
    color: #95C1CD;
  }
}

.main_top_2 {
  background: #fff url(../assets/top_bg3.png) no-repeat;
  background-size: 7.5rem 4.31rem;

  .colors {
    color: #C58202;
  }

  .xian2 {
    color: #E5CB83;
  }

}

.main_top_3 {
  background: #fff url(../assets/top_bg4.png) no-repeat;
  background-size: 7.5rem 4.31rem;

  .colors {
    color: #048493;
  }

  .xian2 {
    color: #85C6CE
  }

  ;
}

.black {
  .main_top_0 {
    background: #1E1F26 url(../assets/top_bg11.png) no-repeat;
    background-size: 7.5rem 4.31rem;
  }

  .main_top_1 {
    background: #1E1F26 url(../assets/top_bg22.png) no-repeat;
    background-size: 7.5rem 4.31rem;
  }

  .main_top_2 {
    background: #1E1F26 url(../assets/top_bg33.png) no-repeat;
    background-size: 7.5rem 4.31rem;
  }

  .main_top_3 {
    background: #1E1F26 url(../assets/top_bg44.png) no-repeat;
    background-size: 7.5rem 4.31rem;
  }

  .list[data-v-4eb5aa4a] {
    border-bottom: 0.14rem solid rgba(0, 0, 0, 1);
  }

  .item_title {
    color: #f0f1f5;
  }
}

.card {
  width: 6.8rem;
  height: 3rem;
  margin: 0.1rem 0;
  margin-left: 0.35rem;
  border-radius: 0.24rem;
  position: relative;

  .card_main {
    position: absolute;
    width: 6rem;
    height: 2.5rem;
  }

  .icon_vip3 {
    width: 1.90rem;
    height: 1.79rem;
    position: absolute;
    top: 0.74rem;
    right: 0.42rem;
  }

  .icon_vip0 {
    width: 1.96rem;
    height: 1.96rem;
    position: absolute;
    top: 0.51rem;
    right: 0.45rem;
  }

  .icon_vip1 {
    width: 1.79rem;
    height: 2.08rem;
    position: absolute;
    top: 0.44rem;
    right: 0.42rem;
  }

  .icon_vip2 {
    width: 1.79rem;
    height: 2.09rem;
    position: absolute;
    top: 0.42rem;
    right: 0.43rem;
  }
}

.content {
  height: 0.85rem;

  color: #575554;
}

.swipe0 {
  background: linear-gradient(124deg, #5F96C8 0%, #86B5E9 100%);
  box-shadow: 0px 0.02rem 0.08rem 0px rgba(125, 161, 196, 0.5);
}

.swipe1 {
  background: linear-gradient(124deg, #639FB1 0%, #93C3D2 100%);
  box-shadow: 0px 0.02rem 0.08rem 0px rgba(121, 165, 177, 0.5);
}

.swipe2 {
  background: linear-gradient(124deg, #DCB858 0%, #E1C976 100%);
  box-shadow: 0px 0.02rem 0.08rem 0px rgba(204, 182, 117, 0.5);
}

.swipe3 {
  background: linear-gradient(124deg, #4FB0B8 0%, #7DBFCC 100%);
  box-shadow: 0px 0.02rem 0.08rem 0px rgba(102, 169, 175, 0.5);
  margin-right: 0.5rem;
}

.swipecard4 {
  /deep/.van-swipe__track {
    transform: translateX(-1049px) !important;
  }
}

.list {
  min-height: 2.37rem;
  transition: all 0.4s;
  border-bottom: 0.14rem solid #f5f5f5;

  .title {
    height: 0.8rem;
    padding: 0 0.35rem 0 0.32rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      display: flex;
      align-items: center;

      span {
        padding: 0 0.25rem 0 0.12rem;
        font-size: 0.3rem;
        color: #f7b33d;
      }
    }


    .more {
      img {
        width: 0.19rem;
        height: 0.1rem;
      }

      span {
        padding: 0 0.11rem 0 0.12rem;
      }
    }
  }

  ul {
    padding-left: 0.3rem;

    .item_title {
      line-height: 0.58rem;
      font-size: 0.32rem;
    }
  }

  .pname {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 0.2rem;

    div {
      width: 1.68rem;
      color: #888888;
      font-size: 0.28rem;
      line-height: 0.5rem;
      margin-bottom: 0.1rem;
      display: flex;
      align-items: center;

      p {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.11rem;
        background: #f3b853;
        border-radius: 50%;
      }

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.hytitle {
  display: flex;
  height: 0.9rem;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.33rem 0 0.29rem;
  font-size: 0.32rem;
  font-weight: 500;
  color: #333333;

  img {
    width: 1.94rem;
    height: 0.2rem;
  }
}

.black {
  .hytitle {

    color: #F0F1F5;
  }
}

.btn {
  width: 1.7rem;
  height: 0.56rem;
  border-radius: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  float: right;
}

.btn0 {
  background: #4892ee;
}

.btn1 {
  background: #55a0b4;
}

.btn2 {
  background: #f1b646;
}

.btn3 {
  background: #3bccdb;
}

.white {
  background: #eeeff4;
  color: #333;

  .sub-boot {
    background: #fff;
  }
}

.black {
  color: #676d78;
  background: #000;

  .swipe0 {
    box-shadow: 0px 0.02rem 0.08rem 0px rgba(125, 161, 196, 0.5);
    background: linear-gradient(124deg, #6190BB 0%, #7DA1C8 100%);
  }

  .swipe1 {
    background: linear-gradient(124deg, #679BAB 0%, #8AAEB9 100%);
    box-shadow: 0px 0.02rem 0.08rem 0px rgba(121, 165, 177, 0.5);
  }

  .swipe2 {
    background: linear-gradient(124deg, #C7A957 0%, #CCB97A 100%);
    box-shadow: 0px 0.02rem 0.08rem 0px rgba(204, 182, 117, 0.5);
  }

  .swipe3 {
    background: linear-gradient(124deg, #5AA3AA 0%, #83B2BB 100%);
    box-shadow: 0px 0.02rem 0.08rem 0px rgba(102, 169, 175, 0.5);

  }

  .list {

    border-bottom: 0.14rem solid #000;
  }





  .content {
    color: #434241;
  }

  .sub-boot {
    background: #171c27;
    color: #f0f1f4;
  }

  .textColor {
    /deep/.van-nav-bar__title {
      color: #fff !important;
    }

    /deep/.van-icon {
      color: #fff;
    }

  }

  .textColor1 {
    /deep/.van-nav-bar__title {
      color: #fff !important;
    }

    /deep/.van-icon {
      color: #fff !important;
    }
  }
}

.sub-boot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  text-align: center;
}

.textColor {
  /deep/.van-nav-bar__title {
    color: #333 !important;
  }

  /deep/.van-icon {
    color: #333 !important;
  }
}

.textColor1 {
  /deep/.van-nav-bar__title {
    color: #ffffff !important;
  }

  /deep/.van-icon {
    color: #ffffff !important;
  }
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 100%;
  margin: 0 0.17rem;
}

.sub-boot .agreement {
  display: block;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
}

/deep/.van-nav-bar__left {
  font-size: 16px;
}

// .swiper-container{
//               width:100%;
//               height:300px;
//               margin:20px auto;
//           }
//           .swiper-slide{
//               width:60%;
//               font-size:18px;
//               text-align:center;
//               justify-content:center;
//               align-items:center;
//               display:flex;
//               background:#fff;
//           }
//           .swiper-slide:nth-child(2n){   //设定页面不同的宽度
//               width:40%;
//           }
//           .swiper-slide:nth-child(3n){
//               width:20%;
//           }
.xian1 {
  width: 2.6rem;
  height: 0.18rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.09rem;

  .xian2 {
    width: 1.2rem;
    height: 0.18rem;
    background: rgba(255, 255, 255, 0.7);

    border-radius: 0.09rem;
    font-size: 0.16rem;
    font-family: PingFang SC;
    font-weight: 400;
    // color: #333333;
    padding-left: 0.1rem;
    line-height: 0.18rem;
  }
}

.dian {
  display: flex;
  position: absolute;
  right: 0.52rem;
  top: 2.67rem;

  p {
    width: 5px;
    height: 5px;
    margin-right: 0.08rem;
    background: rgba(255, 255, 255, 0.36);
    border-radius: 50%;
  }

  .activedian {

    background: #FFFFFF;
  }
}
</style>
